import { render } from "./CustomImgComponent.vue?vue&type=template&id=591f8126&ts=true"
import script from "./CustomImgComponent.vue?vue&type=script&lang=ts"
export * from "./CustomImgComponent.vue?vue&type=script&lang=ts"

import "./CustomImgComponent.vue?vue&type=style&index=0&id=591f8126&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__